import axios from "axios";
import { API_BASE_URL } from "../../../environment";
import { getAuthHeaders } from "../../../utils/authUtils";
import { cachedRequest } from "../../../utils/requestCache";

export interface Team {
  team_id: number;
  name: string;
  team_name?: string;
  manager_id: number;
  created_by: any;
  tenant_id: number;
  total_team_members: number;
  manager: {
    user_id: number;
    full_name: string;
    avatar_url: string;
  };
  tenant: any;
}

export const TeamService = {
  getTeams: async (tenantId: number) => {
    return cachedRequest(`team:${tenantId}`, async () => {
      const response = await axios.get(
        `${API_BASE_URL}/team/?tenant_id=${tenantId}&response_mode=light`,
        {
          headers: getAuthHeaders(),
        }
      );
      return response.data.results || [];
    });
  },
};
